import { queryKeyFactory } from '@wyz/utils';
import { CommonQueryKeys } from '~/common/api';

export const containerPricingPolicies = queryKeyFactory({
  base: () => [...CommonQueryKeys.root(), 'container-pricing-policies'],
  bySupplier: function (query: unknown) {
    return [...this.base(), 'by-supplier', query];
  },
  detail: function (policyGroupId: unknown) {
    return [...this.base(), 'detail', policyGroupId];
  },
});
export const containerOrders = queryKeyFactory({
  base: () => [...CommonQueryKeys.root(), 'container-orders'],
  getById: function (query: unknown) {
    return [...this.base(), 'by-id', query];
  },
});
